import type { TShopItem } from '~services/api/credits/types';
import { abbreviateNumber } from '~utils/numbers';

export const transformShopItemToGTMData = (
	item: TShopItem,
	omitListInfo = false
) => {
	const isSubscription = item.meta.subscription;
	const { discountedPrice, price, sku, amount } = item;
	const discountInfo =
		item.discountedPrice !== undefined
			? { discount: parseFloat((item.price - item.discountedPrice).toFixed(2)) }
			: {};

	if (isSubscription) {
		const listInfo = omitListInfo
			? {}
			: {
					item_list_name: 'premium_features',
					item_list_id: 'pf',
			  };
		return {
			price: `${discountedPrice ?? price}`,
			item_id: sku,
			item_name: `${sku.split('.')[4]}onth`,
			item_category: 'membership',
			...discountInfo,
			...listInfo,
		};
	}

	const listInfo = omitListInfo
		? {}
		: {
				item_list_name: 'neurons',
				item_list_id: 'nr',
		  };
	return {
		item_name: `${abbreviateNumber(amount)}neurons`,
		item_id: sku,
		price: `${discountedPrice ?? price}`,
		item_category: 'coinpack',
		...discountInfo,
		...listInfo,
	};
};
